"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const InlineCheckBok = (props) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: 'checkbox-inline', children: (0, jsx_runtime_1.jsxs)("label", { className: 'checkbox', children: [(0, jsx_runtime_1.jsx)("input", { className: props.className, id: props.id || props.name, name: props.name, type: 'checkbox', onChange: val => props.onChange(props.name, val.target.checked), checked: props.value || false, disabled: props.disabled }), (0, jsx_runtime_1.jsx)("span", {}), props.label] }) }));
};
exports.default = InlineCheckBok;
